import { useAuth0 } from '@auth0/auth0-react';
import useGeneralApiCall from 'components/Dashboard/apiCalls/useGeneralApiCall';
import { useContentResults } from 'components/Dashboard/ContentResultsContext';
import { createSectionName } from 'components/Dashboard/helpers/controlActiveFilters';
import useDetectRateMode from 'components/Dashboard/ListControl/useDetectRateMode';
import RatingUpdateBadge from 'components/Dashboard/PriorityUpdates/RatingUpdateBadge';
import { RateUpdateButtons } from 'components/Dashboard/RateUpdatesFeed/RateUpdatesContent';
import useOutsideElement from 'components/Dashboard/utilities/useOutsideElement';
import TransformFromPascalCase from 'components/Settings/Utilities/TransformFromPascalCase';
import transformToPascalCase from 'components/Settings/Utilities/TransformToPascalCase';
import { useRef, useState } from 'react';

const RateUpdatesContentButton = ({ currentNew }) => {
  const [isOpen, setIsOpen] = useState(false);
  const rating = currentNew?.feedback?.importanceRating ?? null;
  const { contentResults, setContentResults, setFeedState } = useContentResults();

  const { generalApiCall } = useGeneralApiCall();

  const actionsElement = useRef(null);
  const buttonNotRef = useRef(null);
  const buttonQuiteRef = useRef(null);
  const buttonVeryRef = useRef(null);

  const hideActions = (e) => {
    setIsOpen(false);
  };
  useOutsideElement(actionsElement, hideActions);
  const sectionName = createSectionName(true);
  const section = contentResults[sectionName];
  const rateUpdate = async ({ rating }) => {
    if (!!currentNew) {
      const newSection = {
        ...section,
        new: {
          ...currentNew,
          feedback: {
            ...currentNew.feedback,
            importanceRating: rating,
          },
        },
      };
      let newContentResults = {
        ...contentResults,
        [sectionName]: newSection,
      };
      setContentResults(newContentResults);

      let targetButton;
      if (rating === 'Not important') {
        targetButton = buttonNotRef.current;
      } else if (rating === 'Quite important') {
        targetButton = buttonQuiteRef.current;
      } else if (rating === 'Very important') {
        targetButton = buttonVeryRef.current;
      }

      if (targetButton && !targetButton.classList.contains('rate-active')) {
        const targetClass = `rate-${rating.split(' ')[0].toLowerCase()}`;
        targetButton.classList.add('rate-active', targetClass);

        const results = await generalApiCall({
          pathname: '/api/feed/add-feedback-importance-rating',
          method: 'post',
          requestProperties: {
            objectId: currentNew.objectId,
            importanceRating: transformToPascalCase(rating),
          },
          needsAuthentication: true,
          returnCompleteRequest: true,
        });

        if (results?.status === 200) {
          await new Promise((resolve) => setTimeout(resolve, 300));
          targetButton.classList.remove('rate-active', targetClass);
          setIsOpen(false);
          if (rating === 'Not important') {
            setFeedState('feedbackItemPopup', {
              ratingScored: 'Negative',
              isOpen: true,
              item: { objectID: currentNew?.objectId },
              keywords: currentNew?.keywordsFromLists,
              contentPage: true,
              firstTime: true,
            });
          }
        }
      }
    }
  };

  const { rateUpdatesMode } = useDetectRateMode();
  const { isAuthenticated } = useAuth0();

  return (
    <>
      {!rateUpdatesMode && isAuthenticated && (
        <div ref={actionsElement} className='position-relative'>
          <button
            className={`general-button border rounded specific-left-padding-12 pr-3 specific-y-padding-5 paragraph-p2 hovered-button ${isOpen ? 'bg-blue-hovered' : ''}`}
            onClick={() => setIsOpen(!isOpen)}
          >
            <span className={`dropdown-item-element dropdown-item-element-9 ${isOpen ? 'open' : ''}`}>
              {rating ? (
                <RatingUpdateBadge content={true} item={{ rating: TransformFromPascalCase(rating) }} />
              ) : (
                <>How important is this update to you?</>
              )}
            </span>
          </button>
          {isOpen && (
            <>
              <div
                className='rounded box-shadow px-4 py-3 position-absolute z-extra-max'
                style={{ width: 'max-content', maxWidth: '670px', left: 0, top: 'calc(100% + 5px)' }}
              >
                <RateUpdateButtons
                  rateUpdate={rateUpdate}
                  rating={TransformFromPascalCase(rating)}
                  buttonRefs={{ buttonNotRef, buttonQuiteRef, buttonVeryRef }}
                  contentPage={true}
                />
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
};

export default RateUpdatesContentButton;
